import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2018',
    ecrans: ['00-2'],
    params: ['?ovdcleintref']
});
